<template>
  <v-card flat>
    <v-card-title class="mb-1">
      {{ SBlockType.name }}
    </v-card-title>
    <v-card-subtitle>
      {{ SBlockType.description }}
    </v-card-subtitle>
  </v-card>
</template>

<script>
/***
 * presentation of info about the type of speech block
 *
 * @description use with prop {Object} SBlockType - type of speech block
 */
export default {
  name: 'SBlockTypeInfo',
  props: {
    SBlockType: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
